import React, { memo } from 'react'

import Active from '../../commons/Active'
import Inactive from '../../commons/Inactive'
import TableCell from '../../commons/TableCell'
import ResultsTable from '../../ResultsTable'

import { useHasOperation } from 'hooks/useHasOperation'
import { OPERACIONES_MODULOS } from 'utils/constants'

const ModuleTable = ({ isSearch, order, modules, searchModules, actionEdit, cleanCallback }) => {
   const EDITAR_MDDULO = useHasOperation(OPERACIONES_MODULOS.EDITAR_MODULO)
   const VER_CODIGO_MODULOS = useHasOperation(OPERACIONES_MODULOS.VER_CODIGO_MODULOS)

   const columns = [
      {
         title: 'NOMBRE MÓDULO',
         field: 'name',
         align: 'center',
         sorting: !!isSearch,
         customSort: () => 0,
         defaultSort: order,
         render: rowData => <TableCell text={rowData?.name} />
      },
      {
         title: 'DESCRIPCIÓN MÓDULO',
         field: 'description',
         align: 'center',
         sorting: false,
         render: rowData => <TableCell text={rowData?.description} />
      },
      {
         title: 'ESTADO MÓDULO',
         field: 'status',
         align: 'center',
         sorting: false,
         render: rowData => (rowData?.status === 'A' ? <Active /> : <Inactive />)
      },
      {
         title: 'URL APLICACIÓN',
         field: 'link',
         sorting: false,
         align: 'center'
      },
      {
         title: 'NOMBRE APLICACIÓN',
         field: 'application.name',
         sorting: false,
         align: 'center',
         render: rowData => <TableCell text={rowData?.application?.name} />
      },
      {
         title: 'FECHA REGISTRO',
         field: 'createdDate',
         sorting: false,
         align: 'center'
      },
      {
         title: 'USUARIO REGISTRO',
         field: 'createdBy',
         sorting: false,
         align: 'center'
      }
   ]

   const customActions = [
      EDITAR_MDDULO && {
         icon: 'edit',
         tooltip: 'Editar fila',
         onClick: (_, rowData) => actionEdit(rowData)
      }
   ]

   return (
      <ResultsTable
         columns={columns}
         tableData={modules}
         isSearch={isSearch}
         searchCallback={searchModules}
         cleanCallback={cleanCallback}
         actionEdit={actionEdit}
         order={order}
         customActions={customActions}
         enableKey={VER_CODIGO_MODULOS}
      />
   )
}

export default memo(ModuleTable)
